export default {
  computed: {
    judgeOnBoardingSteps: function () {
      return [
        {
          target: '[judge-on-boarding=step-1]',
          header: {
            title: '<span>_____<span> <span class="numbers">1 / 5</span>'
          },
          content: this.$t('onboarding.judgeRegistration.step1'),
          params: {
            placement: 'top'
          }
        },
        {
          target: '[judge-on-boarding=step-2]',
          header: {
            title: '<span>_____<span> <span class="numbers">2 / 5</span>'
          },
          content: this.$t('onboarding.judgeRegistration.step2'),
          params: {
            placement: 'top'
          }
        },
        {
          target: '[judge-on-boarding=step-3]',
          header: {
            title: '<span>_____<span> <span class="numbers">3 / 5</span>'
          },
          content: this.$t('onboarding.judgeRegistration.step3')
        },
        {
          target: '[judge-on-boarding=step-4]',
          header: {
            title: '<span>_____<span> <span class="numbers">4 / 5</span>'
          },
          content: this.$t('onboarding.judgeRegistration.step4')
        },
        {
          target: '[judge-on-boarding=step-5]',
          header: {
            title: '<span>_____<span> <span class="numbers">5 / 5</span>'
          },
          content: this.$t('onboarding.judgeRegistration.step5')
        }
      ]
    }
  }
}
